import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_NZ',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  'c98d45ff-58bd-49e4-bd0c-0d662e6170af',
  ''
);
